module.exports = __webpack_public_path__ + "img/screenshot1-b.71ec9305.jpg";